var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,95c-3.584,0-6.5-2.916-6.5-6.5v-73c0-3.584,2.916-6.5,6.5-6.5h37c1.78,0,2.278,1.707,3.5,3l19.219,18.03 C85.366,31.239,86,32.828,86,34.5v54c0,3.584-2.916,6.5-6.5,6.5H24.5z",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M22.5,93c-3.584,0-6.5-2.916-6.5-6.5v-73C16,9.916,18.916,7,22.5,7h37 c1.78,0,3.502,0.742,4.724,2.035L82.219,28.03C83.366,29.239,84,30.828,84,32.5v54c0,3.584-2.916,6.5-6.5,6.5H22.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#70bfff",
    d: "M22,83V17c0-2.209,1.791-4,4-4h30.286c1.095,0,2.142,0.449,2.897,1.241l17.714,18.6 C77.605,33.585,78,34.573,78,35.6V83c0,2.209-1.791,4-4,4H26C23.791,87,22,85.209,22,83z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2785bd",
    d: "M59,15v16c0,1.105,0.895,2,2,2h16l-1-2.653l-15-15.5L59,15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#40396e",
    d: "M73.5,88h-47c-3.033,0-5.5-2.467-5.5-5.5v-65c0-3.033,2.467-5.5,5.5-5.5h33 c0.412,0,0.806,0.169,1.089,0.468l18,19C78.853,31.747,79,32.116,79,32.5v50C79,85.533,76.533,88,73.5,88z M26.5,15 c-1.378,0-2.5,1.122-2.5,2.5v65c0,1.378,1.122,2.5,2.5,2.5h47c1.378,0,2.5-1.122,2.5-2.5V33.098L58.855,15H26.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.75,47h-29.5c-0.829,0-1.5-0.671-1.5-1.5s0.671-1.5,1.5-1.5h29.5c0.829,0,1.5,0.671,1.5,1.5 S65.579,47,64.75,47z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.75,57h-29.5c-0.829,0-1.5-0.671-1.5-1.5s0.671-1.5,1.5-1.5h29.5c0.829,0,1.5,0.671,1.5,1.5 S65.579,57,64.75,57z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.75,67h-17.5c-0.829,0-1.5-0.671-1.5-1.5s0.671-1.5,1.5-1.5h17.5c0.829,0,1.5,0.671,1.5,1.5 S53.579,67,52.75,67z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsIcon);
export default __webpack_public_path__ + "static/media/docs-icon.0d1b11ebdfd8b9df29a073d7a7cde28b.svg";
export { ForwardRef as ReactComponent };